import {
  ACTIVE_PROJECT_ERROR,
  ACTIVE_PROJECT_LOADING,
  ACTIVE_PROJECT_SUCCESS,
  ADD_PROJECT_ERROR,
  ADD_PROJECT_LOADING,
  ADD_PROJECT_SUCCESS,
  ADD_TIME_ENTRY_ERROR,
  ADD_TIME_ENTRY_LOADING,
  ADD_TIME_ENTRY_SUCCESS,
  DELETE_ENTRY_ERROR,
  DELETE_ENTRY_SUCCESS,
  GET_ALL_ENTRIES_ERROR,
  GET_ALL_ENTRIES_LOADING,
  GET_ALL_ENTRIES_SUCCESS,
  GET_ENTRY_ERROR,
  GET_ENTRY_LOADING,
  GET_ENTRY_SUCCESS,
  GET_PROJECT_ERROR,
  GET_PROJECT_LOADING,
  GET_PROJECT_SUCCESS,
  GET_TIME_ENTRY_ERROR,
  GET_TIME_ENTRY_LOADING,
  GET_TIME_ENTRY_SUCCESS,
  SUPERVISOR_ALL_ENTRIES_SUCCESS,
  SUPERVISOR_TEAM_SUCCESS,
  UPDATE_ENTRY_ERROR,
  UPDATE_ENTRY_LOADING,
  UPDATE_ENTRY_SUCCESS,
  UPDATE_FLAG_ERROR,
  UPDATE_FLAG_LOADING,
  UPDATE_FLAG_SUCCESS,
  WEEK_PROJECT_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  page_loading: false,
  result: [],
  typesData: [],
  projectData: [],
  projectResult: [],
  timeEntryResult: [],
  allEntries: [],
  entryResult: [],
  allprojectResult: [],
  teamMembers: [],
  teamEntries:[],
  error: "",
  updatedResult: "",
  statusMessage: "",
  addEntryError: "",
  flagMessage: "",
  addEntryMessage: "",
  updateEntryError: "",
  updateProjectMessage: "",
  deleteProjectMessage: "",
};

const timeEntryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_PROJECT_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case ACTIVE_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        allprojectResult: action.payload,
      };
    case ACTIVE_PROJECT_ERROR:
      return {
        ...state,
        loading: false,
        allprojectResult: [],
        error: action.payload,
      };
    case SUPERVISOR_ALL_ENTRIES_SUCCESS:
      return{
        ...state,
        loading:false,
        entryResult:action.payload
        // teamEntries:action.payload
      }
    case SUPERVISOR_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        teamMembers: action.payload,
      };
    case GET_ALL_ENTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        page_loading: false,
        entryResult: action.payload,
        error: "",
        takeLeaveError: "",
      };
    case GET_ENTRY_LOADING:
      return {
        ...state,
        page_loading: action.payload,
        loading: action.payload,
      };
    case GET_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        page_loading: false,
        entryResult: action.payload,
        error: "",
        takeLeaveError: "",
      };
    case GET_ENTRY_ERROR:
      return {
        ...state,
        loading: false,
        page_loading: false,
        entryResult: [],
        error: action.payload,
      };
    case UPDATE_FLAG_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case UPDATE_FLAG_SUCCESS:
      return {
        ...state,
        loading: false,
        addEntryMessage: action.payload,
      };
    case UPDATE_FLAG_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_TIME_ENTRY_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case GET_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        timeEntryResult: action.payload,
      };
    case GET_TIME_ENTRY_ERROR:
      return {
        ...state,
        loading: false,
        timeEntryResult: [],
        error: action.payload,
      };
    case GET_ALL_ENTRIES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_ALL_ENTRIES_ERROR:
      return {
        ...state,
        loading: false,
        allEntries: [],
      };
    case UPDATE_ENTRY_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case UPDATE_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        addEntryMessage: action.payload,
      };
    case UPDATE_ENTRY_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case ADD_PROJECT_LOADING:
      return {
        ...state,
        loading: action.payload,
        addEntryError: "",
      };
    case ADD_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case ADD_PROJECT_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case ADD_TIME_ENTRY_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case ADD_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        timeEntryResult: action.payload,
        addEntryMessage: action.payload,
      };
    case ADD_TIME_ENTRY_ERROR:
      return {
        ...state,
        loading: false,
        timeEntryResult: [],
        error: action.payload,
      };
    case GET_PROJECT_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case GET_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case GET_PROJECT_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case DELETE_ENTRY_SUCCESS:
      return {
        ...state,
        addEntryMessage: action.payload,
      };
    case DELETE_ENTRY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case WEEK_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    default:
      return state;
  }
};
export default timeEntryReducer;
